const smoothScroll = param => {
  const element = document.getElementById(param.id)
  if (!element) {
    return
  }
  window.scroll({
    top: element.offsetTop - param.offset,
    behavior: "smooth",
  })
}

export default smoothScroll
